<template>
  <div v-if="!stripe_charges_enabled && isOwner">
    <a
      href="/stripe/refresh/"
      target="_blank"
      class="cursor-pointer text-center rounded-md bg-surface-primary px-5 py-1 font-semibold text-fg-error -mt-4 inline-block shadow-podHover mx-auto"
    >
      Your Stripe setup is not complete. Please click here to continue.
    </a>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useSettingStore } from '@/stores/setting'
import { useUserStore } from '@/stores/user'

const settingStore = useSettingStore()
const { stripe_charges_enabled } = storeToRefs(settingStore)
const userStore = useUserStore()
const { isOwner } = storeToRefs(userStore)
</script>
